import client from './api-client';
export const getConfiguracionForm19 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form19: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosCierreGetion = async(query) => {
    try {
        
        const response = await client.get(`caso/implicado?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosCierreGestion: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboRegistrarHito = async(query) => {
    try {
        
        const response = await client.get(`cfg-trazabilidad?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboRegistrarHito: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const postActualizarCierre = async(file) => {
    try {
        
        const response = await client.post('getion-implicado/cierre', file);
       
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaModalCierre: response.data};
        } else {
            return {respuestaModalCierre: response.data};
        }

    } catch(error){
        throw error;
    }
}
export const getMediosPago= async(query) => {
    try {
        
        const response = await client.getSelect(`detalles?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                mediosDePago: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getMaxNumeroCuotas = async(query) => {
    try {
        
        const response = await client.get(`parametros?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getBancos = async(query) => {
    try {
        
        const response = await client.getSelect(`bancos?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                bancos: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getCalculoMontoCuota = async(query) => {
    try {
        const response = await client.getSelect(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                calculoMontoCuota: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }
    } catch(error){
        throw error;
    }
}
export const serviceCerrarCaso = async(body) => {
    try {
        const response = await client.post('getion-implicado/cierre', body);
        //return {code:1, object:[], message:'Cierre de gestión procesado correctamente.'};//response.data;
        return response.data;
    } catch(error) {
        throw error;
    }
}